import {
  CustomAction,
  eventCustomActionClicked,
  WappInput,
  WappMode,
} from '@weblite-wapps/protocol'
import { findByIdAsync } from '@weblite/persist'
import {
  findRunningWapp,
  getWappInput as getWappInputFromWappSession,
} from 'weblite-web-wapprunner'
import { getWis } from '$logic/wises'
import { sendEventToWapp } from '../wapp-communication.publish'

const modeToPrivilegeLevel: Record<WappMode, number> = {
  [WappMode.INLINE]: 1,
  [WappMode.STATIC]: 1,
  [WappMode.MAIN]: 1,
  [WappMode.OVERLAY]: 2,
}

const getModePrivilege = (mode: WappMode) => modeToPrivilegeLevel[mode] || 2

export const hasPrivilegeToOpen = (
  parentMode: WappMode,
  wappToOpenMode: WappMode,
) =>
  wappToOpenMode !== WappMode.INLINE &&
  getModePrivilege(parentMode) <= getModePrivilege(wappToOpenMode)

export const sendCustomActionToWapp = (
  wappSessionId: string,
  customAction: CustomAction,
) => {
  const {
    wappSessionId: foundWappSessionId,
    wappId,
    wisId,
    mode,
  } = findRunningWapp(wappSessionId)

  if (foundWappSessionId)
    sendEventToWapp(
      eventCustomActionClicked(
        { name: customAction },
        { wappSessionId, wappId, wisId, mode },
      ),
    )
}

export async function getWappInput(wappSessionId: string, wisId?: string) {
  const wis = wisId ? await getWis(wisId) : null
  return {
    ...wis?.customize,
    ...getWappInputFromWappSession(wappSessionId),
  } as WappInput
}
